export default __webpack_public_path__ + "static/media/panel1@2x.b37a73fe.png";